module.exports = __webpack_public_path__ + "img/09_maska_4-kvadrata.1077d79.svg";